<template>
    <a-modal :title="`刻章费用(${state.kezhang?.full_name ?? ''})`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消支付</a-button>
            <a-button type="primary" :loading="state.submitLoading" @click="onFormSubmit">立即支付</a-button>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 6 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formData.type" button-style="solid">
                        <a-radio :value="8">微信扫码付款</a-radio>
                        <a-radio :value="1">对公账户</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formData.type == 1">
                    <a-form-item label="附件" name="attachment" required>
                        <Upload :upload_path="state.kezhang.upload_path"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                    <a-form-item label="该笔转账到账金额" name="public_money" required>
                        <a-input v-model:value="formData.public_money" placeholder="请输入付款金额"
                            style="width: 400px"></a-input>
                    </a-form-item>
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.remark" placeholder="请输入备注"
                            style="width: 400px"></a-textarea>
                    </a-form-item>
                </div>
                <div v-if="formData.type == 8">
                    <a-form-item label="需要支付金额">
                        <div style="font-size: 24px; color: red; line-height: 24px">
                            <div v-if="state.coupon_use_id >= 1">
                                <span class="red" style="text-decoration: line-through">￥{{ state.pay_amount_total
                                }}
                                </span>
                                <span>，优惠了￥{{ state.discount_amount_total }}</span>
                                <a-button type="primary" @click="useCoupon"
                                    style="background: #ff6b26; margin-left: 10px" size="small"
                                    v-if="state.isselected_coupon">
                                    使用了优惠券（{{ state.isselected_coupon.coupon_type == 1 ? '直减现金券' :
                                        state.isselected_coupon.coupon_type == 2 ? '满减现金券' : '折扣券' }}：{{
                                        state.isselected_coupon.name
                                    }}√）</a-button>
                                <a style="margin-left: 20px; font-size: 14px" @click="deleteCoupon">删除优惠券</a>
                            </div>
                            <div v-else>
                                ￥{{ state.actually_paid_total
                                }}<a-button type="primary" @click="useCoupon"
                                    style="background: #ff6b26; margin-left: 10px" size="small"
                                    v-if="state.coupon_use_list.length > 0">使用优惠券</a-button>
                            </div>
                        </div>
                    </a-form-item>
                    <a-form-item label="优惠后需要支付金额" v-if="state.coupon_use_id >= 1">
                        <div style="font-size: 24px; color: red; margin-top: -4px">￥{{ state.actually_paid_total }}
                        </div>
                    </a-form-item>
                </div>
            </a-form>
        </a-skeleton>
    </a-modal>
    <UseCoupons v-if="state.showCoupon" v-model:couponId="state.coupon_use_id" :businessType="2"
        :tableColumnsData="{ id: props.kezhangId }" @cancel="
            () => {
                state.showCoupon = false
            }
        " @ok="UseCouponsOk"></UseCoupons>
    <!-- 微信扫码支付 -->
    <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
        () => {
            emit('ok')
        }
    "></WechatPayQrcode>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref, h, onUnmounted } from 'vue'
import Upload from '@/components/base/Upload.vue'
import UseCoupons from '@/components/base/UseCoupons.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    kezhangId: {
        type: Number,
        default: 0
    }
})
const state = reactive<any>({
    showQrcode: false, //微信支付二维码
    qrcodeData: {},
    loading: false,
    submitLoading: false,
    kezhang: {}, //刻章主体

    showCoupon: false,
    discount_amount_total: 0, // 总优惠金额
    pay_amount_total: 0, // 总应付金额
    actually_paid_total: 0, // 总实付金额

    coupon_use_list: [], // 优惠券列表
    coupon_use_id: null, // 选中优惠券id
    isselected_coupon: {} //选中的优惠券
})
interface FormDataType {
    type: number
    public_money: number
    remark: string
    attachment: any[]
}
const formData = reactive<FormDataType>({
    type: 8,
    public_money: 0,
    remark: '',
    attachment: []
})
const useCoupon = () => {
    state.showCoupon = true
}
onMounted(() => {
    //刻章只有微信扫码支付
    queryDetail(props.kezhangId)
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/kezhang/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        state.kezhang = res.data
        //获取是否有优惠券
        getComputeOreder(true)
    })
}

const UseCouponsOk = (e) => {
    state.coupon_use_id = e.id
    state.isselected_coupon = e
    state.showCoupon = false
    getComputeOreder()
}
const deleteCoupon = () => {
    state.isselected_coupon = {}
    state.coupon_use_id = null
    getComputeOreder()
}
// 计算订单
const getComputeOreder = (checkSubmit = false) => {
    state.priceLoading = true
    let requeryParam = {
        url: `/admin/v1/kezhang_pay/getComputeOreder`,
        method: 'post',
        data: {
            kezhang_id: props.kezhangId,
            coupon_use_id: state.coupon_use_id
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.priceLoading = false
            state.coupon_use_list = res.data.coupon_use_list
            state.discount_amount_total = res.data.oreder.discount_amount_total // 总优惠金额
            state.pay_amount_total = res.data.oreder.pay_amount_total // 总应付金额
            state.actually_paid_total = res.data.oreder.actually_paid_total // 总实付金额
            if (checkSubmit) {
                //如果没有可用的优惠券就直接提交
                let is_usable = state.coupon_use_list.find((item) => {
                    return item.is_usable == true
                })
                // if (!is_usable) {
                //     onFormSubmit()
                // }
            }
        })
        .catch((res) => {
            message.error(res?.msg ? res.msg : '查询订单失败')
            state.priceLoading = false
            if (res?.data == 'coupon') {
                //优惠券问题，删除此优惠券
                deleteCoupon()
            }
        })
}

// 提交
const onFormSubmit = () => {
    state.submitLoading = true
    let obj: any = {}
    if (formData.type == 1) {
        //对公转账
        obj = {
            id: props.kezhangId, //刻章id
            coupon_use_id: null, //对公不能使用优惠券
            payment_method: 1, //对公转账
            remark: formData.remark, //付款备注
            attachment: formData.attachment, //附件、对公才传附件
            public_money: formData.public_money
        }
    } else if (formData.type == 8) {
        //微信扫码支付
        obj = {
            id: props.kezhangId, //刻章id
            payment_method: 8, //微信扫码支付
            coupon_use_id: state.coupon_use_id
        }
    }
    let requeryParam = {
        url: '/admin/v1/kezhang/initPayOrder',
        method: 'post',
        data: obj
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.msg == 'showqrcode') {
                //显示微信扫的二维码
                state.qrcodeData = {
                    qrcode: res.data.code_url, //二维码url
                    qrcode_money: res.data.qrcode_money, //金额
                    payment_record_id: res.data.payment_record_id, //记录id
                    full_name: res.data.title, //名称
                    trade_type: res.data.trade_type
                }
                state.showQrcode = true
            } else {
                message.success(res.msg)
                emit('ok')
            }
            state.submitLoading = false
        })
        .catch((res) => {
            state.submitLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped>
:deep(.ant-modal-title) {
    margin-bottom: 25px !important;
}

.label-form-item {
    display: flex;
    align-items: center;

    .delete-icon {
        color: red;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;
    }
}

.select-color {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .label-color-picker {
        border: 1px solid #dcdfe6;
        padding: 4px;
        border-radius: 4px;
    }
}
</style>
